var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderTags(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 -960 960 960",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M506.667-298 596-362l88.667 64-33.334-108.667L740-480H631.333L596-586.667 560-480H451.333L540-406.667 506.667-298ZM146.666-160q-27 0-46.833-20.167Q80-200.333 80-226.666v-506.668q0-26.333 19.833-46.499Q119.666-800 146.666-800H414l66.667 66.666h332.667q26.333 0 46.499 20.167Q880-693.001 880-666.667v440.001q0 26.333-20.167 46.499Q839.667-160 813.334-160H146.666Zm0-66.666h666.668v-440.001H453l-66.666-66.667H146.666v506.668Zm0 0v-506.668 506.668Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderTags);
export default __webpack_public_path__ + "static/media/folder-tags.edce32da.svg";
export { ForwardRef as ReactComponent };